import React from "react";
import FileCopyIcon from "@material-ui/icons/FileCopyOutlined";
import { Button } from "@material-ui/core";
import { CopyToClipboard } from "react-copy-to-clipboard";
import "../style.css";

export default ({ url, setIsUrlCopied, isUrlCopied }) => {
    return (
        <div
            className={`url-wrapper ${url ? "url--visible" : "url--hidden"}`}>
            <>
                {url && <p>{url}</p>}
                <CopyToClipboard
                    text={url}
                    onCopy={() => setIsUrlCopied(true)}
                >
                    <Button
                        variant="outlined"
                        disableElevation
                        color="primary"
                        size="small"
                        startIcon={<FileCopyIcon fontSize="small" />}
                    >{isUrlCopied ? "Copied" : "Copy"}
                    </Button>
                </CopyToClipboard>
            </>
        </div>
    );
};